import { Notifier as AirbrakeNotifier } from '@airbrake/browser'
import { createApp } from 'vue'
import { setupAirbrake, privacy, dataLayer, configuration } from '@dpgradio/creative'
import './style.css'
import App from './App.vue'
import router from './router'

const creative = {
  install(app, options) {
    let airbrake = {
      notify: (error) => {
        console.log('[DEV] Airbrake would report:', error)
        return Promise.resolve({ id: 'dev-error-id' })
      },
    }
    const { projectId, projectKey, env } = options.airbrake || {}
    if (projectId) {
      // Pass along the vue app so that we get error logging for free
      airbrake = setupAirbrake(
        AirbrakeNotifier,
        {
          projectId: projectId,
          projectKey: projectKey,
          environment: env,
        },
        app
      )
    }
    app.provide('airbrake', airbrake)

    privacy.initialize()
    dataLayer.initialize()
    dataLayer.pushVirtualPageView()
  },
}

const initialize = async () => {
  try {
    await configuration.retrieveConfigForStation('qmusic_nl')
  } catch (error) {
    alert(`
      Could not load configuration.
      - Have you set up a configuration for this application in Dario (see [updateConfigSchema.js])? If you do not want a custom configuration, remove the application name from the [configuration.retrieveConfigForDetectedStation] call in [main.js].
      - Did you provide a station name? (e.g. through the URL parameter 'stationId') If you want to set the station name in code, replace the configuration retrieval call with [configuration.retrieveConfigForStation('<station-name>', 'qmusic-nl-birthday-2025')] in [main.js].

      ${error}
    `)
  }

  const app = createApp(App)
  app.use(router)
  app.mount('#app')
  const options = {}
  if (import.meta.env.PROD) {
    options.airbrake = {
      projectId: 627174,
      projectKey: 'b16165923bf7f5ea1f50e09a51253849',
      env: 'production',
    }
  }
  app.use(creative, options)
}

initialize()
